/**
 * Form schema for recharge packages
 */
import { createEntitySelectorSchema } from '@/model/baseForm/fields/EntitySelector'
import MembershipLevel from '@/model/dataLayer/api/MembershipSystem/MembershipLevel'
import GlobalConfig from '@/model/global/GlobalSettings'
import EnhancedImageUploader from '@/model/baseForm/fields/EnhancedImageUploader.vue'
import { VSelect, VTextarea, VTextField } from 'vuetify/lib/components'

export const getRechargePackageFormSchema = () => {
  return [{
    name: 'name',
    key: 'name',
    component: VTextField,
    required: true,
    hint: '请输入套餐名称',
    rules: [v => !!v || '套餐名称不能为空', v => (v && v.length <= 50) || '套餐名称不能超过50个字符']
  }, {
    name: 'description',
    key: 'description',
    component: VTextarea,
    required: false,
    hint: '请输入套餐描述',
    rules: [v => (v && v.length <= 200) || '套餐描述不能超过200个字符']
  }, {
    name: 'chargeAmount',
    key: 'chargeAmount',
    component: VTextField,
    required: true,
    hint: '请输入充值金额',
    componentProps: {
      type: 'number'
    },
    rules: [v => !!v || '充值金额不能为空', v => (v && v > 0) || '充值金额必须大于0']
  }, {
    name: 'bonusAmount',
    key: 'bonusAmount',
    component: VTextField,
    required: true,
    hint: '请输入赠送金额',
    default: 0,
    componentProps: {
      type: 'number'
    },
    rules: [v => (v !== null && v !== undefined) || '赠送金额不能为空', v => v >= 0 || '赠送金额不能为负数']
  }, {
    key: 'active',
    name: '状态',
    component: VSelect,
    required: true,
    default: true,
    componentProps: {
      items: [{ text: '激活', value: true }, { text: '未激活', value: false }], itemText: 'text', itemValue: 'value'
    }
  }, {
    key: 'imageUrl', name: '套餐图片', component: EnhancedImageUploader, required: false, hint: '请上传套餐图片'
  }, createEntitySelectorSchema({
    key: 'requiredLevelOrder',
    name: '会员等级要求',
    label: '选择会员等级',
    hint: '请选择所需会员等级（可选）',
    required: false,
    clearable: true,
    noDataText: '暂无会员等级数据，请先创建会员等级',
    loadFunction: async () => {
      try {
        if (!GlobalConfig.systemId) {
          console.warn('No membership system ID found. Please ensure a membership system is set up.')
          return []
        }

        console.log('Loading membership levels with systemId:', GlobalConfig.systemId)

        // Use MembershipLevel entity to load levels
        const levels = await MembershipLevel.getList(true)

        console.log('Processed membership levels:', levels)

        // Sort levels by levelOrder
        return levels.sort((a, b) => a.levelOrder - b.levelOrder)
      } catch (error) {
        console.error('Error loading membership levels:', error)
        return []
      }
    },
    itemText: 'name',
    itemValue: 'levelOrder',
    selectionOnly: true
  }), {
    name: 'sortOrder',
    key: 'sortOrder',
    component: VTextField,
    required: true,
    default: 50,
    hint: '排序顺序，默认为50',
    componentProps: {
      type: 'number'
    },
    rules: [v => (v !== null && v !== undefined) || '排序顺序不能为空', v => v >= 0 || '排序顺序不能为负数']
  }
    // blId is automatically obtained from GlobalConfig.blId
    // No need to include it in the form schema
  ]
}
